export const LogOutHttpPaths = {
  logOut: '/log-out',
};
